<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EqdW5v/cover.jpeg?1684229395966" alt="This image is the cover for the book Matrilocal Son-in-law Is Supreme, Volume 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Matrilocal Son-in-law Is Supreme, Volume 2
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>In the Kunlun Ruins, there were two great stewards, four great deacons, nine great knights, and seven great guilds. He was the High Lord who controlled the Kunlun Ruins, but he was also a leisurely family chef. </strong></p><p>With a tiger in his heart sniffing the rose, shouldering the responsibility of supporting the heavens and the earth, and holding the pot in his hands, just like that, he was a real man!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fan FuYao, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?681b2760